import {
	reAccountingPeriodConstants
}from "./constants"
import actions from '../../../actions'

const initialState = {
	isSending  : false,
	list       : [],
	changed    : null,
	paged      : {},
	pagedAudit : {}
}

export default function (state = initialState, action){
	switch (action.type){
		case reAccountingPeriodConstants.GetList.REQUEST:
		case reAccountingPeriodConstants.GetPaged.REQUEST:
		case reAccountingPeriodConstants.GetPagedAudit.REQUEST:
		case reAccountingPeriodConstants.Create.REQUEST:
		case reAccountingPeriodConstants.Delete.REQUEST:
		case reAccountingPeriodConstants.Restore.REQUEST:
		case reAccountingPeriodConstants.Update.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}

		case reAccountingPeriodConstants.GetList.FAILURE:
		case reAccountingPeriodConstants.GetPaged.FAILURE:
		case reAccountingPeriodConstants.GetPagedAudit.FAILURE:
		case reAccountingPeriodConstants.Create.FAILURE:
		case reAccountingPeriodConstants.Delete.FAILURE:
		case reAccountingPeriodConstants.Restore.FAILURE:
		case reAccountingPeriodConstants.Update.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload,
				changed   : null
			}
		case reAccountingPeriodConstants.GetPaged.SUCCESS:
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case reAccountingPeriodConstants.GetPagedAudit.SUCCESS:
			return {
				...state,
				isSending  : false,
				pagedAudit : action.payload.result
			}
		case reAccountingPeriodConstants.GetList.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reAccountingPeriodConstants.Create.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.create : null
			}
		case reAccountingPeriodConstants.Delete.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.delete : null
			}
		case reAccountingPeriodConstants.Update.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}

		case reAccountingPeriodConstants.Restore.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.restore : null
			}
		case reAccountingPeriodConstants.Clear:
			return {
				...state,
				isSending  : false,
				list       : [],
				changed    : null,
				paged      : {},
				pagedAudit : {}
			}
		default:
			return state
	}
}